import { useSelector } from "react-redux";
import ConfirmationDialog from "../../Dialogs/ConfirmationDialog";
import { RootState } from "../../..";

const DeleteExamDialog = ({
  open,
  handleCancel,
  deleteExam,
}: {
  open: boolean;
  handleCancel: () => void;
  deleteExam: () => void;
}) => {
  const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
  const itemName = selectedRow?.name;
  return (
    <ConfirmationDialog
      isOpen={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => deleteExam()}
      title={`Prüfung ${itemName} löschen?`}
      text={`Möchtest du die Prüfung wirklich unwiderruflich löschen?`}
      cancelTitle="Abbrechen"
      confirmTitle="Löschen"
    />
  );
};

export default DeleteExamDialog;
